import getChannels from "utils/select_options/getChannels";

export const sort = [
  { label: "Tytuł", name: "title" },
  { label: "Id oferty", name: "external_id" },
  { label: "Sku", name: "sku", style: { width: 200 } },
  { label: "Kanał", name: "channel_id", style: { width: 200 } },
];

export const filters = [
  {
    type: "input",
    name: "title",
    sort_id: "title",
    search_type: "matches",
  },
  {
    type: "input",
    name: "external_id",
    sort_id: "external_id",
    search_type: "matches",
  },
  {
    type: "input",
    name: "sku",
    sort_id: "sku",
    search_type: "matches",
  },
  {
    type: "async_select",
    name: "channel_id",
    sort_id: "channel_id",
    search_type: "in",
    getData: getChannels,
  },
];
